import imgWarning from '@/assets/illustrations/warning.svg';

export type OptionType = {
  img?: string;
  title?: string;
  message?: string;
  textBtn1?: string;
  textBtn2?: string;
  goTo1?: string;
  goTo2?: string;
};

export const getOptionsMessages = (title?: string, message?: string) => ({
  unAvailable: {
    img: imgWarning,
    title: title ?? 'Este trámite no se encuentra disponible.',
    message: message ?? '',
    textBtn1: 'Entendido'
  },
  successActivate: {
    title: title ?? 'Descuento activado',
    message:
      message ??
      'Ya puedes realizar el pago de tu ciclo completo con el 10% de dscto.',
    textBtn1: 'Ver detalle de pago',
    textBtn2: 'Ir a pagos',
    goTo1: '/pagos/detalle',
    goTo2: '/pagos'
  },
  errorActivate: {
    title: title ?? 'Este descuento ya ha sido activado',
    message: message ?? 'Verifica el estado en la sección de pagos',
    textBtn1: 'Ir a pagos',
    goTo1: '/pagos'
  },
  successDeactivate: {
    title: title ?? '¡Descuento desactivado con éxito!',
    message: message ?? 'Ya puedes pagar las cuotas por separado.',
    textBtn1: 'Entendido',
    goTo1: '/pagos'
  },
  errorDeactivate: {
    title: title ?? 'Este descuento ya ha sido desactivado',
    textBtn1: 'Entendido',
    goTo1: '/pagos'
  },
  error: {
    img: imgWarning,
    title: title ?? '¡Oh no! <br /> Ha sucedido un error inesperado',
    message: message ?? '',
    textBtn1: 'Entendido'
  }
});
